module.exports = __webpack_public_path__ + "img/cometads-logo.4c8264be.png";